<div data-e2e="flash" class="ui hidden message" [ngClass]="type">
  <div data-e2e="message-flash" class="header" [class.align-center]="centerAlignMessage" [innerHtml]="message"></div>
  <p data-e2e="secondary-message" *ngIf="secondaryMessage" [innerHtml]="secondaryMessage"></p>
</div>